import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import { selectorAppIsSmallScreen, selectorAppIsTouchScreen } from "../App";

const root_ = (theme) => ({
  position: "fixed",
  top: 5,
  right: 5,
  maxHeight: "99vh",
  overflow: "auto",
  opacity: 0.975,
  zIndex: 1,
  [theme.breakpoints.down("sm")]: {
    position: "fixed",
    right: 2,
    top: 60,
    opacity: 0.9,
  },
});

export default function Widgets({ children }) {
  const isSmallScreen = useSelector(selectorAppIsSmallScreen);
  const isTouchScreen = useSelector(selectorAppIsTouchScreen);

  const isVisible = !isSmallScreen && !isTouchScreen;

  return (
    <Box style={{ display: isVisible ? "inherit" : "none" }}>
      <Box sx={root_}>{children}</Box>
    </Box>
  );
}
